<template>
  <v-card :title="$i18n.t('Bird Eye View')" class="px-5 py-3 mx-2 my-0">
    <v-form id="form">
      <v-row>
        <v-col cols="12" md="3">
          <v-card
            class="py-0 my-2"
            elevation="1"
            color="blue lighten-5 d-none d-md-flex"
          >
            <v-card-text class="py-0">
              <v-row>
                <v-col cols="12" md="12">{{ $i18n.t("All Vehicles") }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <div style="width: 100%; height: 600px; overflow: auto; padding: 5px">
            <v-card
              v-for="trip in allActiveEntities"
              :key="trip._id"
              class="py-0 my-2"
              elevation="1"
              @click="setEntityCentre(trip)"
              v-show="!trip.hideMe"
              :color="trip._id == selectedEntity_id ? 'info' : ''"
            >
              <v-card-text class="py-0">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-icon>mdi-car</v-icon>
                    <small>
                      {{ trip.vehicle ? trip.vehicle.regNo : null }}
                      <br />
                      {{ trip.vehicle.vehicleTypeStr }}
                    </small>
                  </v-col>
                  <v-col cols="12" md="12" v-if="trip.driver.name">
                    <v-icon>mdi-account</v-icon>
                    <small>{{ trip.driver ? trip.driver.name : null }}</small>
                    <v-icon>mdi-phone</v-icon>
                    <small>{{ trip.driver ? trip.driver.phone : null }}</small>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
        <v-col cols="12" md="9">
          <v-row>
            <v-col cols="12" md="8">
              <v-radio-group v-model="filter.row" row @change="onRowChange">
                <v-radio :label="$i18n.t('All')" value="0"></v-radio>
                <v-radio :label="$i18n.t('In Service')" value="1"></v-radio>
                <v-radio :label="$i18n.t('On Duty')" value="2"></v-radio>
                <v-radio :label="$i18n.t('Off Duty')" value="3"></v-radio>
                <v-radio
                  :label="$i18n.t('Under Maintenance')"
                  value="4"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <!-- <v-col cols="12" md="2">
              <z-country-select v-model="country" />
            </v-col> -->
            <v-col cols="12" md="2">
              <z-city-select
                v-model="city"
                country="India"
                @inputFull="cityUpdate"
              />
            </v-col>
          </v-row>
          <z-google-map
            :zoom="zoom"
            :center="{ lat: centre.lat, lng: centre.lon }"
            :showSearch="showSearch"
            :showCentreMarker="showCentreMarker"
            :lines="lines"
            :markers="markers"
            @bounds_changed="bounds_changed"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import auth from "@/store/user/module/auth";

@Component
export default class TaxSlabs extends Vue {
  centre = { lat: 28.508, lon: 77.587 };
  zoom = 12;
  lines = [];
  showSearch = false;
  showCentreMarker = false;
  markers = [];
  selectedEntity_id = null;
  eye = { entity: "vehicle" };
  allActiveEntities = null;
  refreshIntervalId = null;
  authContent = { country: 2, city: null };
  currentBounds = null;
  filter = { row: "0" };
  city = null;

  onRowChange() {
    this.reOrderData(this.currentBounds);
  }

  get loading() {
    return common.loading;
  }

  cityUpdate(fullCity) {
    if (fullCity && fullCity.lat && fullCity.lon) {
      this.centre = { lat: fullCity.lat, lon: fullCity.lon };
      this.selectedEntity_id = null; //TODO
    } else {
      this.selectedEntity_id = null;
    }
  }

  async mounted() {
    this.authContent = auth.authContent;
    console.log(this.authContent.country);
    if (this.authContent) {
      if (this.authContent.lat != null && this.authContent.lon != null) {
        this.centre = { lat: this.authContent.lat, lon: this.authContent.lon };
      }
    }
    this.trackEntities(null, null, "vehicle");
  }

  bounds_changed(bounds) {
    this.currentBounds = bounds;
    this.reOrderData(bounds);
  }

  setEntityCentre(entity) {
    this.selectedEntity_id = entity._id;
    this.selectedEntity = entity;
    const locations = [];
    if (entity.location) {
      locations.push(entity);
      const centre = {
        lat: entity.location.lat,
        lon: entity.location.lon,
      };
      if (centre.lat && centre.lon) {
        this.centre = centre;
      }
    }
    this.setMultipleLocations(locations);
  }

  cancelTracking() {
    this.selectedEntity_id = null;
    this.selectedEntity = null;
    this.clearInterval(this.refreshIntervalId);
    this.refreshIntervalId = undefined;
  }

  async fetchActiveRoutes(route_id, forBooking, kind) {
    try {
      common.setLoading(true);
      const response = await doGet(
        "/api/travel/" + kind + "/track/all?forBooking=" + forBooking
      );
      common.setLoading(false);
      this.allActiveEntities = response;
      this.reOrderData(this.currentBounds);
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  setMultipleLocations(locations) {
    this.markers = [];
    const mks = [];
    for (let i = 0; i < locations.length; i++) {
      const freeIcon = {
        url: "/icons/Taxi-Top-Yellow-icon.png",
        // rotation: locations[i].location.heading ? locations[i].location.heading : 150,
      };
      const inservice = {
        url: "/icons/icon_red_car.png",
        // rotation: locations[i].location.heading ? locations[i].location.heading : 150,
      };
      const loc = locations[i].location;
      const trip = locations[i];
      const marker = {
        position: { lat: loc.lat, lng: loc.lon },
        icon: loc.trip_id ? inservice.url : freeIcon.url,
      };
      marker["vehicle_id"] = loc.vehicle_id;
      marker["trip_id"] = loc.trip_id;
      marker["time"] = loc.time;
      marker.infoText =
        '<div><a target="_blank" href="/trip/' +
        trip.trip_id +
        '"><b style="color:blue">' +
        trip.title +
        "</b></a>" +
        "<br>" +
        '<i class="icon-badge"></i> ' +
        trip.dutyType +
        "<br>" +
        '<i class="fa fa-car"></i> ' +
        trip.vehicle.vehicleType +
        " " +
        trip.vehicle.regNo +
        "<br>" +
        '<i class="fa fa-user"></i> ' +
        trip.driver.name +
        ' <i class="fa fa-phone"></i> ' +
        trip.driver.phone +
        "<br>" +
        '<i class="fa fa-hourglass-o"></i> updated: ' +
        Math.round((new Date().getTime() - marker.time * 1000) / 60000) +
        " Mins ago <br>" +
        "<br>" +
        '<i class="fa fa-map-marker" style="color:green;"></i> ' +
        (trip.source ? trip.source.addressLine : "") +
        "<br>" +
        '<i class="fa fa-map-marker" style="color:red;"></i> ' +
        (trip.destination ? trip.destination.addressLine : "") +
        "<br>" +
        "</div>";

      mks.push(marker);
    }
    this.markers = mks;
  }

  trackEntities(entity_id, forBooking, kind) {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
      this.refreshIntervalId = undefined;
    }

    this.fetchActiveRoutes(entity_id, forBooking, kind);

    this.refreshIntervalId = setInterval(
      function () {
        this.fetchActiveRoutes(entity_id, forBooking, kind);
      }.bind(this),
      50000
    );
  }

  reOrderData(bounds) {
    if (!bounds) bounds = {};
    if (!this.allActiveEntities || this.allActiveEntities.length == 0) return;
    const lat1 = bounds.lat1;
    const lat2 = bounds.lat2;
    const lon1 = bounds.lon1;
    const lon2 = bounds.lon2;
    const top = [];
    for (let i = 0; i < this.allActiveEntities.length; i++) {
      if (!this.filterSatisfying(this.allActiveEntities[i])) {
        // continue;
        this.allActiveEntities[i].hideMe = true;
      } else {
        this.allActiveEntities[i].hideMe = false;
      }
      if (this.allActiveEntities[i]._id === this.selectedEntity_id) {
        top.splice(0, 0, this.allActiveEntities[i]);
        this.selectedEntity = this.allActiveEntities[i];
      } else if (
        top.length != 0 &&
        this.fallInBound(
          this.allActiveEntities[i].location,
          lat1,
          lat2,
          lon1,
          lon2
        )
      ) {
        console.log(
          this.allActiveEntities[i].location.lat +
            " " +
            this.allActiveEntities[i].location.lon +
            " " +
            this.allActiveEntities[i].vehicle.regNo
        );
        if (!this.selectedEntity_id)
          top.splice(0, 0, this.allActiveEntities[i]);
        else top.splice(1, 0, this.allActiveEntities[i]);
      } else {
        top.push(this.allActiveEntities[i]);
      }
    }
    this.allActiveEntities = top;
    this.populateLocations(this.allActiveEntities);
  }

  populateLocations(response) {
    if (response && response.length > 0) {
      const locations = [];
      let isSet = false;
      for (let i = 0; i < response.length; i++) {
        if (
          !response[i].hideMe &&
          (!this.selectedEntity_id ||
            this.selectedEntity_id == response[i]._id) &&
          response[i].location
        )
          locations.push(response[i]);
        if (
          !isSet &&
          this.selectedEntity_id &&
          this.selectedEntity_id == response[i]._id &&
          response[i].location
        ) {
          const centre = {
            lat: response[i].location.lat,
            lon: response[i].location.lon,
          };
          if (centre.lat && centre.lon) {
            this.centre = centre;
            isSet = true;
          }
        }
      }
      this.setMultipleLocations(locations);
    }
  }

  filterSatisfying(entity) {
    if (!this.filter) {
      return true;
    }
    if (
      entity.vehicle &&
      this.filter.row != 0 &&
      this.filter.row != entity.vehicle.status
    ) {
      return false;
    }
    if (this.filter.zone) {
      if (this.filter.zone != entity.zone_id) {
        return false;
      }
    }
    if (this.filter.availability) {
      if (
        this.filter.availability == "engaged" &&
        (!entity.location || !entity.location.trip_id)
      ) {
        return false;
      }
      if (
        this.filter.availability == "free" &&
        entity.location &&
        entity.location.trip_id
      ) {
        return false;
      }
    }

    if (!this.filter.vehicle) return true;
    if (
      entity.vehicle &&
      entity.vehicle.regNo &&
      entity.vehicle.regNo
        .toUpperCase()
        .indexOf(this.filter.vehicle.toUpperCase()) != -1
    ) {
      return true;
    }
    if (
      entity.driver &&
      entity.driver.name &&
      entity.driver.name
        .toUpperCase()
        .indexOf(this.filter.vehicle.toUpperCase()) != -1
    ) {
      return true;
    }
    if (
      entity.driver &&
      entity.driver.phone &&
      entity.driver.phone
        .toString()
        .indexOf(this.filter.vehicle.toUpperCase()) != -1
    ) {
      return true;
    }
    return false;
  }

  fallInBound(location, lat1, lat2, lon1, lon2) {
    if (!location || !lat1 || !lat2 || !lon1 || !lon2) return false;
    if (
      lat1 < location.lat &&
      location.lat < lat2 &&
      lon1 < location.lon &&
      location.lon < lon2
    )
      return true;
    if (
      lat1 < location.lat &&
      location.lat < lat2 &&
      lon1 > location.lon &&
      location.lon > lon2
    )
      return true;
    if (
      lat1 > location.lat &&
      location.lat > lat2 &&
      lon1 < location.lon &&
      location.lon < lon2
    )
      return true;
    if (
      lat1 > location.lat &&
      location.lat > lat2 &&
      lon1 > location.lon &&
      location.lon > lon2
    )
      return true;
    return false;
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.btn-list-item {
  padding: 0;
  float: left !important;
}
.btn-list-item .v-btn--text {
  padding: 0;
  text-transform: none;
  font-size: 14px;
  float: left;
  margin: 0;
}
</style>
